import { render, staticRenderFns } from "./Project2.vue?vue&type=template&id=4d421c08&scoped=true&"
import script from "./Project2.vue?vue&type=script&lang=js&"
export * from "./Project2.vue?vue&type=script&lang=js&"
import style0 from "./Project2.vue?vue&type=style&index=0&id=4d421c08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d421c08",
  null
  
)

export default component.exports